import type { Range, Word } from '../types'

/**
 * Phát hiện các khoảng lặng (dead space) giữa các từ dựa trên mốc thời gian
 * transcript. Trả về các khoảng nên cắt, chừa lại một chút đệm cho tự nhiên.
 */
export function detectSilences(words: Word[], minGap = 0.6, pad = 0.12): Range[] {
  const kept = words.filter((w) => !w.removed).sort((a, b) => a.start - b.start)
  const cuts: Range[] = []
  for (let i = 0; i < kept.length - 1; i++) {
    const gap = kept[i + 1].start - kept[i].end
    if (gap > minGap) {
      const s = kept[i].end + pad
      const e = kept[i + 1].start - pad
      if (e - s > 0.05) cuts.push({ start: s, end: e })
    }
  }
  return cuts
}
